import React from "react";
import Link from "gatsby-link";
import Imgix from "react-imgix";
import Icon from "../Icon";
import { ButtonTextNoLink } from "../Buttons";
import { formatDate, endSlash } from "../../util/helperFunctions";

const ListFeedItem = ({ page }) => {
  return (
    <Link
      to={endSlash(page.route)}
      className="list-feed-item flex flex-column-reverse-m bg-stone dark"
    >
      <div className="list-feed-item__info-container w-100 flex flex-column justify-between">
        <div className="">
          {page.eventDate && (
            <p className="p-averta p-lead-averta--m">
              {page.eventDate && formatDate(page.eventDate)}
            </p>
          )}
          {page.template != "Story" &&
          page.template != "Event" &&
          page.template != "Top-Tier-Event" ? (
            <div>
              <p className="p-averta p-lead-averta--m mb0">{page.title}</p>
              <p className="p--small p--m mb0">{page.subtitle}</p>
            </div>
          ) : (
            <p className="p--small p--m mb0">{page.title}</p>
          )}
        </div>
        <div className="flex justify-between items-center">
          {page.template == "Story" ? (
            <div className="flex justify-between items-center">
              <Icon
                path="icon-18-news"
                width="18"
                height="15"
                className="mr1"
              />
              <ButtonTextNoLink
                className="o-40 dark dn db-m"
                text="Read More"
              />
            </div>
          ) : (
            <div className="flex justify-between items-center">
              <Icon
                path="icon-18-event"
                width="16"
                height="17"
                className="mr1"
              />
              <ButtonTextNoLink className="o-40 dn db-m dark" />
            </div>
          )}
          {page.publishedDate && (
            <p className="h-6 mb0">{formatDate(page.publishedDate)}</p>
          )}
        </div>
      </div>
      <div className="list-feed-item__image-container">
        {page.abstractPhoto ? (
          <div className="overflow-hidden h-100 w-100">
            <Imgix
              type="img"
              src={page.abstractPhoto.url}
              className="list-feed-item__image ease-out--l h-100 w-100 image-cover mb0"
              imgixParams={{
                "fp-x": page.abstractPhotoFocalPointX,
                "fp-y": page.abstractPhotoFocalPointY,
                auto: ["compress"],
                fit: "crop",
                crop: "focalpoint"
              }}
              htmlAttributes={{
                alt: page.abstractPhotoAltText
              }}
            />
          </div>
        ) : (
          <div className="bg-gold h-100 w-100" />
        )}
      </div>
    </Link>
  );
};

export default ListFeedItem;



// WEBPACK FOOTER //
// ./src/components/PageHelpers/ListFeedItem.js